import React, { Component } from 'react';
import UserService from '../Services/UserService';
import ReCAPTCHA from "react-google-recaptcha";
import { ValidatorForm } from 'react-form-validator-core';
import { TextValidator } from '../Configuration/TextValidator';

const initialState = {
    selected: 'Select',
    NSUID: 'NSUID',
    SSN: 'SSN',
    sharklinkCountdown: false,
    sharkLinkInformation: false,
    sharklinkMessage: true,
    sharklinkMessageError: false,
    sharklinkMessageErrorVal: '',
    groupNSUID: false,
    groupSSN: false,
    ssn_val: 'XXX-XX-',
    nsuid_val: '',
    year: '',
    month: '',
    day: '',
    data: [],
    fields: {},
    errors: {},
    apimessage: '',
    chkAgree: '',
    is_btnsubmit: false

};
const recaptchaRef = React.createRef();
const site_key = process.env.REACT_APP_SITE_KEY;
const time_show_info = process.env.REACT_APP_TIME_SHOW;
const urlhome = process.env.REACT_APP_URL_HOME === 'undefined' ? '' : process.env.REACT_APP_URL_HOME;

const PATTERN_NUMERIC_DAY_AND_MONTH = process.env.REACT_APP_PATTERN_NUMERIC_DAY_AND_MONTH;
const PATTERN_NUMERIC_YEAR = process.env.REACT_APP_PATTERN_NUMERIC_YEAR;
// const PATTERN_NUMERIC_SSN = process.env.REACT_APP_PATTERN_NUMERIC_SSN;
// const PATTERN_NUMERIC_NSUID = process.env.REACT_APP_PATTERN_NUMERIC_NSUID;
const REACT_APP_MESSAGE_MONTH_FORMAT = process.env.REACT_APP_MESSAGE_MONTH_FORMAT;
const REACT_APP_MESSAGE_DAY_FORMAT = process.env.REACT_APP_MESSAGE_DAY_FORMAT;
const REACT_APP_MESSAGE_YEAR_FORMAT = process.env.REACT_APP_MESSAGE_YEAR_FORMAT;

export class Login extends Component {

    constructor(props) {
        super(props);


        this.form = React.createRef();

        this.state = initialState;

        this.showSharkLinkInformation = this.showSharkLinkInformation.bind(this);
        this.showNSUIDField = this.showNSUIDField.bind(this);
        this.showSSNField = this.showSSNField.bind(this);
        this.IdentityOptionChange = this.IdentityOptionChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.ChangeUpperCase = this.ChangeUpperCase.bind(this);
        this.OnKeyPress = this.OnKeyPress.bind(this);
        this.OnKeyPressNSUID = this.OnKeyPressNSUID.bind(this);
        this.OnKeyPressNumeric = this.OnKeyPressNumeric.bind(this);
        this.hideSharkLinkInformation = this.hideSharkLinkInformation.bind(this);
        this.GenerateMessageValidator = this.GenerateMessageValidator.bind(this);
        this.GenerateMessageValidatorFormat = this.GenerateMessageValidatorFormat.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.handlePasteNSUID = this.handlePasteNSUID.bind(this);
        this.ShowError = this.ShowError.bind(this);
        this.OnKeyUpMonth_Day = this.OnKeyUpMonth_Day.bind(this);
        this._user_service = new UserService();
        ValidatorForm.addValidationRule('lengthInText', (value) => {

            return true;
        });
    }

    handlePasteNSUID(event) {
        // Get pasted data via clipboard API
        var strIn = event.clipboardData.getData('Text');
        var patt = /^[Nn][0-9]{8}/;
        if (!patt.test(strIn)) {
            this.setState(state => ({
                sharklinkMessageError: true,
                sharklinkMessageErrorVal: 'The NSU ID (N#) is incorrect'

            }));
            event.preventDefault();
            return false;
        }
    }
    handlePaste(event) {
        // Get pasted data via clipboard API

        event.preventDefault();
        return false;

    }
    ChangeUpperCase() {
        var nsuid_valUpper = this.state.nsuid_val.toLocaleUpperCase();
        this.setState(state => ({
            nsuid_val: nsuid_valUpper
        }));
    }

    reset() {
        this.setState(initialState);
    }

    validatecheckbox() {

        if (this.state.chkAgree === '') {

            this.setState(state => ({
                chkAgree: false

            }));
            return false;
        }
        return this.state.chkAgree;
    }
    handleSubmit(event) {
        event.preventDefault();

        const recaptchaValue = process.env.REACT_APP_IsRecapcha_Enabled === 'true' ? recaptchaRef.current.getValue() : 'false';
        var nsuid = this.state.groupNSUID === true ? this.state.nsuid_val.toLocaleUpperCase() : this.state.ssn_val.substring(7);
        var month = this.state.month.length < 2 ? '0' + this.state.month : this.state.month;
        var day = this.state.day.length < 2 ? '0' + this.state.day : this.state.day;
        var dob = this.state.year + "-" + month + "-" + day;
        var msg = "Form has errors.";
        //Validate DOB
        const dateformat = /^\d{4}-\d{2}-\d{2}$/;

        if (!dateformat.test(dob)) {

            msg = "Birthdate not is correct";
        }
        if (this.validatecheckbox() && recaptchaValue !== '') {

            this.setState(state => ({
                is_btnsubmit: true
            }), () => {
                console.log(this.state.is_btnsubmit);

                if (this.state.groupNSUID) {
                    this._user_service.getCellphoneValidation(this.state.nsuid_val)
                        .then(response => {
                            debugger;
                            console.log(response);

                            if (response) {
                                this._user_service.getDOBValidation(dob)
                                    .then(response => {
                                        if (response) {
                                            this.getUserInfo(nsuid, dob);
                                        } else {
                                            this.ShowError('The DoB does not exits.')
                                        }
                                    })

                            } else {
                                this.ShowError('The cellular does not exists.')
                            }

                        });

                } else {
                    this._user_service.getpassportValidation(this.state.ssn_val.substring(7))
                        .then(response => {
                            debugger;
                            console.log(response);

                            if (response) {
                                this._user_service.getDOBValidation(dob)
                                    .then(response => {
                                        if (response) {
                                            this.getUserInfo(nsuid, dob);
                                        } else {
                                            this.ShowError('The DoB does not exits.')
                                        }
                                    })

                            } else {
                                this.ShowError('The passport does not exists.')
                            }

                        });
                }



            });

        } else {

            if (recaptchaValue === '') msg = "Check the captcha.";
            this.ShowError(msg);
        }

    }

    getUserInfo(nsuid, dob) {
        this._user_service.getUserInfo(nsuid, dob)
            .then(response => {

                return response;
            }).then(result => {

                this.setState(state => ({
                    data: result,
                    sharklinkMessage: false,
                    sharklinkMessageError: false,
                    is_btnsubmit: false
                }));

                this.showSharkLinkInformation();

            }).catch(error => {
                this.ShowError(error.message);

            });
    }

    ShowError(error) {
        this.setState(state => ({
            sharklinkMessageError: true,
            sharklinkMessageErrorVal: error,
            is_btnsubmit: false,
            sharklinkCountdown: false,
            sharkLinkInformation: false,

        }));
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        event.persist();
        this.setState({
            [name]: value
        });

    }

    OnKeyPress(event) {

        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

        // const re = new RegExp(PATTERN_NUMERIC_DAY_AND_MONTH); // /^[0-9]{1,2}$/;
        var patt = /^[0-9]{1,2}$/;
        if (!patt.test(key)) {

            event.preventDefault();
            return false;
        }


    }
    OnKeyUpMonth_Day(event) {

        if (event.target.value.length === 2) {
            if (event.target.id === 'month')
                document.getElementById('day').focus();
            else
                document.getElementById('year').focus();

        }


    }

    OnKeyPressNSUID(event) {


        // Convert the character code to a string
        var strIn = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        var patt = '';
        // The current cursor position is stored as: e.target.selectionStart
        if (event.target.selectionStart === 0 && event.target.value[0] !== 'n' && event.target.value[0] !== 'N') {
            // Setup our pattern, excluding anything other than a-zA-Z
            patt = /^[Nn]/;
        } else {
            // Setup our pattern to allow alpha, spaces and dashes
            patt = /[0-9]{1,8}/;
        }
        if (!patt.test(strIn)) {
            console.log(false);
            event.preventDefault();
            return false;
        }


    }

    OnKeyPressNumeric(event) {

        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

        const pattern1 = /^[0-9]$/;

        if (!pattern1.test(key)) {

            event.preventDefault();
            return false;
        }

    }

    OnKeyDownSsn(event) {
        var ctl = document.getElementById('ssn_val');
        var startPos = 6;
        var pos = ctl.selectionStart;
        var KeyID = event.keyCode;
        var isDelete = (KeyID === 46);
        var isBackspace = (KeyID === 8);
        var letPassKey = true;

        if (isDelete && pos <= startPos) letPassKey = false;
        if (isBackspace && pos <= startPos + 1) letPassKey = false;

        if (!letPassKey) {
            event.preventDefault();
            return false;
        }
    }

    OnKeyDownNsu(event) {
        var ctl = document.getElementById('nsuid_val');
        var startPos = 0;
        var pos = ctl.selectionStart;
        var KeyID = event.keyCode;
        var isDelete = (KeyID === 46);
        var isBackspace = (KeyID === 8);
        var letPassKey = true;

        if (isDelete && pos <= startPos) letPassKey = false;
        if (isBackspace && pos <= startPos + 1) letPassKey = false;

        if (!letPassKey) {
            event.preventDefault();
            return false;
        }
    }

    showNSUIDField(show) {
        if (show) {
            this.setState(state => ({
                groupNSUID: true,
            }));

        } else {

            this.setState(state => ({
                groupNSUID: false,
            }));

        }
        var nId = document.getElementById('nsuid_val');
        if (!nId.value) this.setState(state => ({
            nsuid_val: ''
        }));
        return
    }

    showSSNField(show) {
        if (show) {

            this.setState(state => ({
                groupSSN: true
            }));
        } else {

            this.setState(state => ({
                groupSSN: false,

            }));
        }
        var ssnId = document.getElementById('ssn_val');
        if (!ssnId.value) this.setState(state => ({
            ssn_val: 'XXX-XX-'
        }));
    }

    showSharkLinkInformation() {

        this.setState(state => ({
            // sharklinkCountdown: true,
            sharkLinkInformation: true,
        }));
        var identityTimeout = setTimeout(function () {
            window.location.pathname = '/' + urlhome;
            this.hideSharkLinkInformation();
            clearTimeout(identityTimeout);
        }, time_show_info);
    }

    hideSharkLinkInformation() {
        document.getElementById('sharklinkCountdown').fadeOut();
        document.getElementById('sharkLinkInformation').fadeOut();
    }

    IdentityOptionChange(event) {

        this.setState({ selected: event.target.value }, () => {

            switch (this.state.selected) {
                case 'NSUID':
                    this.showNSUIDField(true);
                    this.showSSNField(false);
                    break;
                case 'SSN':
                    this.showNSUIDField(false);
                    this.showSSNField(true);
                    break;
                default:
                    this.showNSUIDField(false);
                    this.showSSNField(false);
                    break;
            }
        });


    }



    onChangeCapcha(value) {
        console.log("Captcha value:", value);
    }
    componentDidMount() {

    }

    GenerateMessageValidator(validatorssn) {
        var messagevalidatorssn = [];
        var isminNumber = false;
        var ismaxNumber = false;
        var valueminNumber = '';
        var valuemaxNumber = '';
        var msg = '';
        var lengthInText = '';
        validatorssn.forEach((item) => {
            var [vali, value] = item.split(':');


            switch (vali) {
                case 'lengthInText':
                    lengthInText = value;
                    break;
                case 'required':
                    messagevalidatorssn.push(process.env.REACT_APP_MESSAGE_REQUIRED);
                    break;
                case 'maxStringLength':
                    var txt = (lengthInText === '') ? value : lengthInText;
                    msg = process.env.REACT_APP_MESSAGE_MAX_STRING_LENGTH.replace('X', txt);
                    messagevalidatorssn.push(msg);
                    break;
                case 'minStringLength':
                    var txt2 = (lengthInText === '') ? value : lengthInText;
                    msg = process.env.REACT_APP_MESSAGE_MIN_STRING_LENGTH.replace('X', txt2);
                    messagevalidatorssn.push(msg);
                    break;
                case 'matchRegexp':
                    msg = process.env.REACT_APP_MESSAGE_REGEXP
                    messagevalidatorssn.push(msg);
                    break;
                case 'minNumber':
                    isminNumber = true;
                    valueminNumber = value;
                    if (isminNumber && ismaxNumber)
                        msg = process.env.REACT_APP_MESSAGE_RANGE_NUMBER.replace('X', valueminNumber).replace('Y', valuemaxNumber);
                    else
                        msg = process.env.REACT_APP_MESSAGE_MIN_NUMBER.replace('X', value);

                    messagevalidatorssn.push(msg);

                    break;
                case 'maxNumber':
                    ismaxNumber = true;
                    valuemaxNumber = value;
                    if (isminNumber && ismaxNumber)
                        msg = process.env.REACT_APP_MESSAGE_RANGE_NUMBER.replace('X', valueminNumber).replace('Y', valuemaxNumber);
                    else
                        msg = process.env.REACT_APP_MESSAGE_MAX_NUMBER.replace('X', value);

                    messagevalidatorssn.push(msg);

                    break;
                default:
                // code block
            }

        });
        return messagevalidatorssn;
    }
    GenerateMessageValidatorFormat(validatorssn, message) {
        var messagevalidatorssn = [];
        var isminNumber = false;
        var ismaxNumber = false;
        var valueminNumber = '';
        var valuemaxNumber = '';
        var msg = '';
        validatorssn.forEach((item) => {
            var [vali, value] = item.split(':');


            switch (vali) {
                case 'required':
                    messagevalidatorssn.push(process.env.REACT_APP_MESSAGE_REQUIRED);
                    break;
                case 'maxStringLength':
                    msg = process.env.REACT_APP_MESSAGE_MAX_STRING_LENGTH.replace('X', value)
                    messagevalidatorssn.push(msg);
                    break;
                case 'minStringLength':
                    msg = message;
                    messagevalidatorssn.push(msg);
                    break;
                case 'matchRegexp':
                    msg = process.env.REACT_APP_MESSAGE_REGEXP
                    messagevalidatorssn.push(msg);
                    break;
                case 'minNumber':
                    isminNumber = true;
                    valueminNumber = value;
                    if (isminNumber && ismaxNumber)
                        msg = process.env.REACT_APP_MESSAGE_RANGE_NUMBER.replace('X', valueminNumber).replace('Y', valuemaxNumber);
                    else
                        msg = process.env.REACT_APP_MESSAGE_MIN_NUMBER.replace('X', value);

                    messagevalidatorssn.push(msg);

                    break;
                case 'maxNumber':
                    ismaxNumber = true;
                    valuemaxNumber = value;
                    if (isminNumber && ismaxNumber)
                        msg = process.env.REACT_APP_MESSAGE_RANGE_NUMBER.replace('X', valueminNumber).replace('Y', valuemaxNumber);
                    else
                        msg = process.env.REACT_APP_MESSAGE_MAX_NUMBER.replace('X', value);

                    messagevalidatorssn.push(msg);

                    break;
                default:
                // code block
            }

        });
        return messagevalidatorssn;
    }

    render() {
        var isRequiredNSUID = this.state.groupNSUID;
        var isRequiredssn = !this.state.groupNSUID;
        var validatorssn = isRequiredssn ? ['required', 'lengthInText:4', 'minStringLength:11', 'maxStringLength:11'] : [];
        var messagevalidatorssn = isRequiredssn ? this.GenerateMessageValidator(validatorssn) : []; //['Required', 'Please enter max 4 caracters', 'Please enter min 4 caracters', 'The SSN have incorrect format']

        //Validator Month
        var monthvalidator = ['required', 'minStringLength:2', 'maxStringLength:2', 'minNumber:1', 'maxNumber:12', `matchRegexp:${PATTERN_NUMERIC_DAY_AND_MONTH}`];
        var messagemonthvalidator = this.GenerateMessageValidatorFormat(monthvalidator, REACT_APP_MESSAGE_MONTH_FORMAT);

        //Validator Day
        var dayvalidator = ['required', 'minStringLength:2', 'maxStringLength:2', 'minNumber:1', 'maxNumber:31', `matchRegexp:${PATTERN_NUMERIC_DAY_AND_MONTH}`];
        var messagedayvalidator = this.GenerateMessageValidatorFormat(dayvalidator, REACT_APP_MESSAGE_DAY_FORMAT);

        //Validator Year
        var yearvalidator = ['required', 'minStringLength:4', 'maxStringLength:4', `maxNumber:${new Date().getFullYear()}`, `matchRegexp:${PATTERN_NUMERIC_YEAR}`];
        var messageyearvalidator = this.GenerateMessageValidatorFormat(yearvalidator, REACT_APP_MESSAGE_YEAR_FORMAT);

        //Validator NSUID
        var nsuidvalidator = isRequiredNSUID ? ['required', 'lengthInText:10', 'minStringLength:10', 'maxStringLength:10'] : [];
        var messagensuidvalidator = this.GenerateMessageValidator(nsuidvalidator);

        var btnValue = this.state.is_btnsubmit ? 'Loading' : 'Submit';
        var disabled = this.state.is_btnsubmit ? 'disabled' : '';

        //Recapcha        
        var capcha = process.env.REACT_APP_IsRecapcha_Enabled === 'true' ? <ReCAPTCHA ref={recaptchaRef} sitekey={site_key} onChange={this.onChangeCapcha} /> : "";
        //Render
        return (
            <div id="content-wrapper" role="main">

                <section className="s01 wysiwyg bg-white ">
                    <div className="container">
                        <div className="row">
                            <div className="column col-xs-12 col-md-12">
                                <h3>Retrieve Your NSU Identity - International Students</h3>
                            </div>

                            <div className="column col-xs-12 col-md-12">
                                <h4>What is My NSU Identity?</h4>
                                <p className="nsu-p">My NSU International is the <strong>digital identity</strong> for students, faculty, staff and alumni. My NSU International consist of a username/Sharklink ID, password, NSU ID#, and email address.</p>

                                <p className="nsu-p">For your security, please select one of the options (Phone/Cellular # or last 4 digits of Visa/Passport#).</p>
                                <p className="nsu-p"><span className="required">*</span> Indicates required.</p>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="s02 v-fullimage bg-white block featureditemsblock">
                    <div className=" container ">
                        <div className="row block">
                            <div className="column col-xs-12 col-md-12">
                                <div className=" cdiv ">
                                    <div>
                                        <div className="row">
                                            <div className="col-xs-12 col-md-6 col-sm-6 ">


                                                <ValidatorForm noValidate id="frmRetrieveIdentity" onSubmit={this.handleSubmit} ref={this.form} >

                                                    <div className="row">
                                                        <div className="form-group col-md-9">
                                                            <label>Select Below <span className="required">*</span></label>
                                                            <select name="identityOption" id="identityOption" required value={this.state.selected} onChange={this.IdentityOptionChange}>
                                                                <option value='Select'>Select... </option>
                                                                <option value='NSUID' >Phone / Cellular </option>
                                                                <option value='SSN'>Last 4 digits of Visa / Passport</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div id="groupNSUID" className="row" style={{ display: this.state.groupNSUID ? 'block' : 'none' }}>
                                                        <div className="form-group col-md-9">
                                                            <label>Phone / Cellular <span className="required">*</span></label>
                                                            <TextValidator type="text" name="nsuid_val" id="nsuid_val" maxLength='10' minLength='10'
                                                                value={this.state.nsuid_val}
                                                                onChange={this.handleInputChange}
                                                                // onKeyUp={this.ChangeUpperCase}
                                                                onKeyPress={this.OnKeyPressNumeric}
                                                                // onKeyDown={this.OnKeyDownNsu}
                                                                // onPasteCapture={this.handlePaste}
                                                                validators={nsuidvalidator}
                                                                errorMessages={messagensuidvalidator}
                                                            />


                                                        </div>
                                                    </div>

                                                    <div id="groupSSN" className="row" style={{ display: this.state.groupSSN ? 'block' : 'none' }}>
                                                        <div className="form-group col-md-9">
                                                            <label>LAST 4 DIGITS OF PASSPORT/VISA <span className="required">*</span></label>
                                                            <TextValidator type="text" name="ssn_val" id="ssn_val" maxLength='11' minLength='11' required={isRequiredssn}
                                                                value={this.state.ssn_val}
                                                                onChange={this.handleInputChange}
                                                                onKeyPress={this.OnKeyPressNumeric}
                                                                onKeyDown={this.OnKeyDownSsn}
                                                                onPasteCapture={this.handlePaste}
                                                                validators={validatorssn}
                                                                errorMessages={messagevalidatorssn}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <label>Date of Birth <span className="required">*</span></label>
                                                        </div>

                                                        <div className="form-group col-md-3">
                                                            <label className="sub-label">Month (MM)</label>

                                                            <TextValidator type="text" name="month" id="month" maxLength='2'
                                                                value={this.state.month}
                                                                onChange={this.handleInputChange}
                                                                onKeyPress={this.OnKeyPress}
                                                                onKeyUp={this.OnKeyUpMonth_Day}
                                                                onInvalid={this.OnInvalid}
                                                                onInput={this.OnInput}
                                                                onPasteCapture={this.handlePaste}
                                                                validators={monthvalidator}
                                                                errorMessages={messagemonthvalidator}

                                                            />
                                                            <span className="error" aria-live="polite"></span>
                                                        </div>

                                                        <div className="form-group col-md-3">
                                                            <label className="sub-label">Day (DD)</label>
                                                            <TextValidator type="text" name="day" id="day" maxLength='2'
                                                                value={this.state.day}
                                                                onChange={this.handleInputChange}
                                                                onKeyPress={this.OnKeyPress}
                                                                onKeyUp={this.OnKeyUpMonth_Day}
                                                                onPasteCapture={this.handlePaste}
                                                                validators={dayvalidator}
                                                                errorMessages={messagedayvalidator}

                                                            />
                                                        </div>

                                                        <div className="form-group col-md-3">
                                                            <label className="sub-label">Year (YYYY)</label>
                                                            <TextValidator type="text" name="year" id="year" maxLength='4' minLength='4'
                                                                value={this.state.year}
                                                                onChange={this.handleInputChange}
                                                                onKeyPress={this.OnKeyPressNumeric}
                                                                onPasteCapture={this.handlePaste}
                                                                validators={yearvalidator}
                                                                errorMessages={messageyearvalidator}


                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">

                                                            <p className="nsu-p">NSU enforces the Acceptable Use Policy. All users have the responsibility to use our technology resources in an efficient, ethical, and legal manner. Access to such resources is limited to authorized users and is for approved purposes only. If you misuse your account, these privileges may be withheld.</p>

                                                            <p className="nsu-p">Note: When the information entered has been validated, your Sharklink identity will appear for <strong>60 seconds</strong> and then <strong>auto-erase</strong>.</p>


                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group col-md-12">

                                                            <label className="checkbox-button">

                                                                <input type="checkbox" className="checkbox-button__input"
                                                                    id="chkAgree" name="chkAgree" checked={this.state.chkAgree} value={this.state.chkAgree}
                                                                    onChange={this.handleInputChange}
                                                                    validators={['required']}
                                                                    errorMessages={['Required']}
                                                                />

                                                                <span className="checkbox-button__control"></span>
                                                                <span className="checkbox-button__label"><span className="required">*</span> I have read and
                                                                    understood the above rules for the Acceptable Use Policy and agree to abide by them.</span>

                                                            </label>
                                                            <span id='errorchkAgree' style={{ display: this.state.chkAgree === false ? 'block' : 'none' }} className='error' >This field is required.</span>
                                                        </div>
                                                    </div>

                                                    {capcha}
                                                    <p>&nbsp;</p>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <button type="submit" className="btn btn-primary" disabled={disabled}
                                                                id="btnSubmit"  >{btnValue}</button>
                                                        </div>
                                                    </div>
                                                </ValidatorForm>
                                            </div>
                                            <div className="col-xs-12 col-md-6 col-sm-6">
                                                <div id="sharklinkMessage" className="nsu-message nsu-message-info" style={{ display: this.state.sharklinkMessage ? 'block' : 'none' }}>
                                                    Note: If you are unable to retrieve your NSU Identity, please contact SharkIT Help: (954)262-4357 or 800-541-6682 ext. 24357.
                                                </div>

                                                <div id="sharklinkMessageError" className="nsu-message nsu-message-warning" style={{ display: this.state.sharklinkMessageError ? 'block' : 'none' }}>
                                                    Error: {this.state.sharklinkMessageErrorVal}
                                                </div>

                                                <div id="sharklinkCountdown" className="nsu-message nsu-message-warning"
                                                    style={{ display: this.state.sharklinkCountdown ? 'block' : 'none' }}>
                                                    Note: Your SharkLink Identity will display for <strong>60 seconds</strong> and then
                                                    disappear.
                                                </div>

                                                <div id="sharkLinkInformation" className="nsu-message nsu-message-info"
                                                    style={{ display: this.state.sharkLinkInformation ? 'block' : 'none' }}>
                                                    <div className="row">
                                                        <div className="col-md-12 text-center">
                                                            <label>YOUR SHARKLINK IDENTITY</label>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <label className="col-md-6 text-right">SharkLink ID</label>
                                                        <span className="col-md-6">{this.state.data.userName}</span>
                                                    </div>

                                                    <div className="row">
                                                        <label className="col-md-6 text-right">NSU Email Address</label>
                                                        <span className="col-md-6">{this.state.data.email}</span>
                                                    </div>

                                                    <div className="row">
                                                        <label className="col-md-6 text-right">NSU ID</label>
                                                        <span className="col-md-6">{this.state.data.nsuid}</span>
                                                    </div>

                                                    <div className="row text-center">
                                                        <span>First time NSU users please click the below link to reset your password
                                                            <a href="https://reset.nova.edu"> https://reset.nova.edu</a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 endtext"> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="s03 wysiwyg bg-white ">
                    <div className="container">
                        <div className="row">
                            <div className="column col-xs-12 col-md-12">

                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}
